// extracted by css-extract-rspack-plugin
module.exports =  {"loader":"DrawingCanvasLoader-Ibo3__loader"};